var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2953 11.2945C22.6999 11.6934 22.6999 12.3066 22.2953 12.7055C21.2973 13.6896 19.7335 15.0889 17.8956 16.2378C16.0472 17.3933 13.9936 18.25 12 18.25C10.0064 18.25 7.95284 17.3933 6.1044 16.2378C4.26651 15.0889 2.70267 13.6896 1.70466 12.7055C1.30012 12.3066 1.30012 11.6934 1.70466 11.2945C2.70267 10.3104 4.26651 8.91115 6.1044 7.76223C7.95284 6.60671 10.0064 5.75 12 5.75C13.9936 5.75 16.0472 6.60671 17.8956 7.76223C19.7335 8.91115 21.2973 10.3104 22.2953 11.2945Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3.25,
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.d2916728d255abb3fc8b44963a951c78.svg";
export { ForwardRef as ReactComponent };